export const CEIC = {
  name: "Community Engagement Impact Conference",
  edition: "CEIC 2027",
  theme: "From Events to Evidence",
  dates: "March 30–31, 2027",
  startDate: "2027-03-30",
  endDate: "2027-03-31",
  format: "Virtual",
  capacity: 500,
  registrationOpen: false,
  url: "https://communityengagementimpactconference.com/",
  networkUrl: "https://ceopractitionernetwork.com",
} as const;

export const CEIC_PRICING = [
  { id: "member", label: "CEO Practitioner Network member", price: 129, maxAttendees: 1, requiresActiveMembership: true, requiresTeamPass: false, condition: "Active CEO Practitioner Network membership required. Membership is separate from conference admission." },
  { id: "individual", label: "Individual", price: 229, maxAttendees: 1, requiresActiveMembership: false, requiresTeamPass: false, condition: "Conference admission for one attendee." },
  { id: "team", label: "Agency team pass", price: 895, maxAttendees: 5, requiresActiveMembership: false, requiresTeamPass: false, condition: "One agency team pass covers up to five attendees." },
  { id: "additional", label: "Additional agency attendee", price: 179, maxAttendees: 1, requiresActiveMembership: false, requiresTeamPass: true, condition: "Per additional agency attendee, available only after an agency team pass. Not a standalone ticket." },
] as const;

export const CEIC_DISMISSAL_KEY = "tb-ceic-2027-dismissed-until";
export const CEIC_DISMISSAL_MS = 7 * 24 * 60 * 60 * 1000;
export function shouldShowCeicAnnouncement(dismissedUntil: string | null, now: number) {
  const expiry = Number(dismissedUntil);
  return !Number.isFinite(expiry) || expiry <= now;
}

export const CEIC_EVENT = {
  "@context": "https://schema.org",
  "@type": "Event",
  name: `${CEIC.name} (${CEIC.edition})`,
  description: `${CEIC.theme}. A national virtual conference for law enforcement Community Engagement professionals, ${CEIC.dates}. Limited to ${CEIC.capacity} attendees. Registration is not yet open.`,
  startDate: CEIC.startDate,
  endDate: CEIC.endDate,
  eventStatus: "https://schema.org/EventScheduled",
  eventAttendanceMode: "https://schema.org/OnlineEventAttendanceMode",
  location: { "@type": "VirtualLocation", url: CEIC.url },
  url: CEIC.url,
  maximumAttendeeCapacity: CEIC.capacity,
  organizer: { "@type": "Organization", name: "CEO Practitioner Network", url: CEIC.networkUrl },
};